import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import Stack from '@mui/material/Stack';
import { Theme } from '@mui/material/styles';
import Switch from '@mui/material/Switch';
import Typography from '@mui/material/Typography';
import { SxProps } from '@mui/system';
import { get } from 'lodash-es';
import {
  Control,
  Controller,
  FieldErrors,
  FieldPath,
  FieldValues,
} from 'react-hook-form';

interface FieldProps<TFieldValues extends FieldValues = FieldValues> {
  altLabel?: string;
  control: Control<TFieldValues>;
  disabled?: boolean;
  errors?: FieldErrors<TFieldValues>;
  isRequired?: boolean;
  label?: string;
  labelPlacement?: 'end' | 'start' | 'top' | 'bottom';
  name: string;
  sx?: SxProps<Theme>;
  value: boolean;
}
export const SwitchFormField = <TFieldValues extends FieldValues = FieldValues>({
  errors,
  name,
  control,
  disabled = false,
  isRequired = false,
  label,
  altLabel,
  labelPlacement = 'end',
  sx,
}: FieldProps<TFieldValues>) => {
  return (
    <FormControl error={Boolean(get(errors, name))} sx={{ ...sx }}>
      <Stack direction="row" spacing={0} sx={{ alignItems: 'center' }}>
        {altLabel && (
          <Typography
            variant="body1"
            sx={{ mr: 1, color: disabled ? 'text.disabled' : 'text.primary' }}
            component={'label'}
          >
            {altLabel}
          </Typography>
        )}
        <FormControlLabel
          disabled={disabled}
          labelPlacement={labelPlacement}
          control={
            <Controller
              rules={{ required: isRequired }}
              name={name as FieldPath<TFieldValues>}
              control={control}
              render={({ field: props }) => (
                <Switch
                  {...props}
                  checked={Boolean(props.value)}
                  disabled={disabled}
                  onChange={(e) => props.onChange(e.target.checked)}
                />
              )}
            />
          }
          label={label || ''}
        />
      </Stack>
    </FormControl>
  );
};
